import { useResetPassSet } from "@/features/user/hooks/use-reset-pass-set";
import { ResetPassSetService } from "@/features/user/services/reset-pass-set-service";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { PasswordForm } from "@/shared/components/text-box/password-form";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { LoginHeader } from "@/shared/components/header/login-header";
import { Footer } from "@/shared/components/footer/footer";
import { StrengthBar } from "@/shared/components/strength-bar/strength-bar";
import { useErrorContext } from "@/shared/context/error-context";
import { MoneyLinkException, MoneyLinkWarning } from "@/shared/utils/custom-exception";

export const ResetPassSet = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token") ?? "";
  const navigate = useNavigate();
  const resetPassSetService = new ResetPassSetService();
  const { setError } = useErrorContext();
  const [initSuccess, setInitSuccess] = useState(false);

  const {
    password,
    passwordConfirm,
    passwordError,
    isActiveUpdateButton,
    onChangePassword,
    onChangePasswordConfirm,
    changeUpdateButtonState,
    onClickUpdate,
  } = useResetPassSet();

  useEffect(() => {
    const load = async () => {
      try {
        await resetPassSetService.resetPassSetInit({token: token});
        setInitSuccess(true);
      } catch (error) {
        if (error instanceof MoneyLinkException) {
          const { messageBody } = error.error.props;
          setError(new MoneyLinkWarning({
            title: "エラー",
            message: messageBody
          }));
          navigate(EndpointPathNames.LOGIN);
        } else {
          // ネットワークエラー等
          navigate("/error");
        }
      }
    };

    load();
  }, [navigate]);

  useEffect(() => {
    if (!initSuccess) return;
    changeUpdateButtonState();
  }, [password, passwordConfirm, initSuccess]);

  // ログイン画面遷移
  const pushLoginView = () => {
    navigate(EndpointPathNames.LOGIN);
  };

  // パスワードフォームに付与するID
  const passwordFormId = "signUpPass";
  // 次へボタンに付与するID
  const nextButtonId = "next_button_id";
  // キャンセルボタンに付与するID
  const cancelButtonId = "cancel_button_id";

  return (
    <>
      <LoginHeader content="パスワードの再設定" />
      <main>
        <section id="rePass">
          <nav className="step">
            <ol>
              <li className="done">再設定メールを送信</li>
              <li className="active">新パスワードの設定</li>
              <li>再設定完了</li>
            </ol>
          </nav>
          <p>新しいパスワードを設定してください</p>
          <ul className="form">
            <li>
              <PasswordForm
                onChange={onChangePassword}
                id={passwordFormId}
                initialValue={password}
                // errorMessage={passwordError}
                title="新しいパスワード"
              />
              <StrengthBar password={password} />
              <PasswordForm
                onChange={onChangePasswordConfirm}
                id={passwordFormId}
                // errorMessage={passwordError}
                title="新しいパスワード（確認用）"
                className="signUpPass"
                placeholder="上と同じ内容をもう一度入力"
              />
              {passwordError && <span className="pass_error">{passwordError}</span>}
            </li>
          </ul>
          <nav className="btns">
            <span style={{ marginRight: "0.3rem"}}>
              <BaseRoundButton
                className="btn-base"
                id={cancelButtonId}
                buttonText="キャンセル"
                onClick={pushLoginView}
                isActive={true}
              />
            </span>
            <BaseRoundButton
              id={nextButtonId}
              buttonText="次へ"
              onClick={() => onClickUpdate(token, password, passwordConfirm)}
              isActive={isActiveUpdateButton}
              className="nav-main"
            />
          </nav>
        </section>
      </main>
      <Footer />
    </>
  );
};
